import styled from 'styled-components';

import { azure7 } from 'approot/shared/styles/colours.style';
import { FillInBlanksFieldValue } from '../fill-in-blanks-view-answers.style';

export const FillInBlanksSuggestedAnswers = styled.div`
  ${FillInBlanksFieldValue} {
    color: ${azure7};
  }
`;
